import { useQuery } from "@tanstack/react-query";
import httpClient from "../httpClient";
import { HttpError } from "../httpError";
import { schoolFeeFeeAssignmentKey } from "../../constants";
import { SchoolFeeFeeAssignmentResult } from "../../models/schoolFee";

const useSchoolFeeFeeAssignment = ({
  coreServiceId,
  selectionId,
  authorisation = "",
  enabled = true,
}: {
  coreServiceId: string;
  selectionId: string;
  authorisation?: string;
  enabled?: boolean;
}) =>
  useQuery<SchoolFeeFeeAssignmentResult, HttpError>(
    schoolFeeFeeAssignmentKey(coreServiceId, selectionId),
    () =>
      httpClient("schoolfee/fee-assignment", { authorisation }).get<
        SchoolFeeFeeAssignmentResult
      >({
        core_service_id: coreServiceId,
        // Opaque and forwarded exactly as the catalogue gave it.
        selection_id: selectionId,
      }),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled: enabled && !!coreServiceId && !!authorisation && !!selectionId,
    }
  );

export default useSchoolFeeFeeAssignment;
